import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { prepareImgixParams } from '../services/APIClient';

class ModalGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setSelectedImage: this.props.setSelectedImage,
      selectedImage: this.props.selectedImage.url ? this.props.selectedImage : props.images[0],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        selectedImage: nextProps.selectedImage.url
          ? nextProps.selectedImage : this.props.images[0],
      });
    }
  }

  setSelectedImage = (selectedImageIndex) => {
    this.state.setSelectedImage(this.props.images[selectedImageIndex]);
  }

  render() {
    const { selectedImage } = this.state;
    const thumbnails = (
      <div className="row thumbnails-up-8 mb-0 mt-base">
        {this.props.images.map(({ id, originalName, url }, index) => (
          <div className="thumb-col" key={id}>
            <a
              onClick={() => this.setSelectedImage(index)}
              role="button"
              tabIndex="0"
            >
              <img
                src={prepareImgixParams(url, { w: 100, h: 100, auto: 'format,compress' })}
                alt={originalName}
                className="thumbnail"
                style={{ width: '100%' }}
              />
            </a>
          </div>
        ))}
      </div>
    );
    return (
      <div>
        <img
          src={prepareImgixParams(selectedImage.url, {
            w: 640, h: 480, fit: 'contain', auto: 'format,compress',
          })}
          alt={selectedImage.originalName}
          className="float-center"
        />
        {thumbnails}
      </div>
    );
  }
}

ModalGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    url: PropTypes.string,
    originalName: PropTypes.string,
  })).isRequired,
  setSelectedImage: PropTypes.func.isRequired,
  selectedImage: PropTypes.shape({
    url: PropTypes.string,
  }),
};

ModalGallery.defaultProps = {
  images: [{
    id: '',
    url: '',
    originalName: '',
  }],
  selectedImage: {
    url: '',
  },
};

export default ModalGallery;
